export const MIN_PICK_COUNT = 2;
